<!--
 * @Description: 本周推荐模块 -- PC端
 * @Author: Cursor
 * @Date: 2026-04-02
 * @LastEditors: Cursor
 * @LastEditTime: 2026-04-02
-->
<template>
	<section class="weekly-recommend">
		<h2 class="weekly-recommend__title">{{ title }}</h2>
		<div class="weekly-recommend__groups">
			<article
				v-for="(group, groupIndex) in weeklyRecommendGroups"
				:key="`weekly-group-${groupIndex}`"
				class="weekly-recommend__group"
			>
				<div
					v-for="(item, itemIndex) in group"
					:key="item.id"
					class="weekly-recommend__item"
					:class="{
						'weekly-recommend__item--cover': itemIndex === 0,
						'weekly-recommend__item--text': itemIndex !== 0,
					}"
					@click="toWeeklyRecommend(item.jump_url)"
				>
					<img
						v-if="itemIndex === 0"
						class="weekly-recommend__cover"
						:src="item.pc_cover || item.cover_cc"
						:alt="item.name"
					/>
					<template v-else>
						<span class="weekly-recommend__name">{{ item.name }}</span>
						<span class="weekly-recommend__arrow">&gt;</span>
					</template>
				</div>
			</article>
		</div>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { goLink } from "~/utils/common";

const props = defineProps({
	data: {
		type: Object,
		default: () => [],
	},
	title: {
		type: String,
		default: "本週推薦",
	},
	schannel: {
		type: String,
		default: "calc-weekly-pc",
	},
});

const weeklyRecommendGroups = computed(() => {
	const list = Array.isArray(props.data) ? props.data.slice(0, 6) : [];

	return list.reduce((groups, item, index) => {
		const groupIndex = Math.floor(index / 3);
		groups[groupIndex] ||= [];
		groups[groupIndex].push(item);
		return groups;
	}, []);
});

const toWeeklyRecommend = url => {
	logEvent("home_Weekly_click");
	goLink(url, props.schannel);
};
</script>

<style lang="scss" scoped>
.weekly-recommend {
	width: 426px;
	min-height: 642px;
	display: flex;
	flex-direction: column;
	font-family: PingFang SC;

	&__title {
		margin: 0 0 14px;
		font-weight: 500;
		font-size: 20px;
		line-height: 28px;
		color: #1f2329;
	}

	&__groups {
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: 16px;
	}

	&__group {
		flex: 1;
		padding: 16px 24px;
		background: #ffffff;
		border: 1px solid #ececec;
		border-radius: 12px;
	}

	&__item {
		cursor: pointer;
	}

	&__item--cover {
		margin-bottom: 8px;
	}

	&__item--text {
		height: 44px;
		padding: 10px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px dashed rgba(217, 217, 255, 0.5);

		&:last-child {
			border-bottom: none;
		}
	}

	&__cover {
		display: block;
		width: 378px;
		height: 151px;
		object-fit: cover;
		border-radius: 8px;
	}

	&__name {
		min-width: 0;
		font-family: Helvetica Neue;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		color: #2b2f36;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__arrow {
		margin-left: auto;
		font-size: 20px;
		line-height: 20px;
		color: #8b8b8b;
	}
}
</style>
